import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { theme } from '_constants/theme';
import { sanitizePhoneNumber } from '_helpers/common';
import { selectCustomerId, selectDetails, selectError, selectUpdating } from '_store/user/selector';
import { updateMe } from '_store/user/slice';

import Card from 'components/atomic/layouts/Card';
import Text from 'components/atomic/layouts/Text';
import ContactInfoForm from 'components/composed/forms/ContactInfoForm';

const StyledHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${theme.spaces.small}px;
`;

const StyledBody = styled.div``;

const ContactInfoView = () => {
  const dispatch = useDispatch();
  const customerId = useSelector(selectCustomerId);
  const details = useSelector(selectDetails);
  const updating = useSelector(selectUpdating);
  const error = useSelector(selectError);

  const { firstName, lastName, email, phone, address } = details || {};

  const handleSubmit = useCallback(
    (values) => {
      if (values) {
        const { firstName, lastName, email, phone, ...restValues } = values;
        dispatch(
          updateMe({
            customerId,
            body: { firstName, lastName, email, phone: sanitizePhoneNumber(phone), address: { ...restValues } },
          })
        );
      }
    },
    [customerId]
  );

  return (
    <Card>
      <StyledHeader>
        <Text size={theme.fontSizes.medium} weight={600}>
          Primary Contact Information
        </Text>
      </StyledHeader>
      <StyledBody>
        <ContactInfoForm
          error={error}
          loading={updating}
          defaultValues={{ firstName, lastName, email, phone, ...address }}
          onSubmit={handleSubmit}
        />
      </StyledBody>
    </Card>
  );
};

export default ContactInfoView;
